import React, { useEffect, useState } from 'react';
import { CustomResponsiveTable } from '../../../components/common/SimpleResponsiveTable';

import { Drawer, Empty, Tooltip, notification, Typography, Badge, Button, Card, Alert } from 'antd';
import UIStore from '../../../stores/UIStore';
import UserStore from '../../../stores/UserStore';
import api from '../../../utils/api';
import { IParts } from '../../../types/types';
import { EnhancedViewer as Viewer } from '@partsbadger/threedviewer';
import Search from 'antd/lib/input/Search';

import { EyeOutlined, ShoppingCartOutlined, FileUnknownOutlined, NotificationOutlined } from '@ant-design/icons';

import { ColumnProps, TableProps, TablePaginationConfig } from 'antd/es/table';
import { ErrorRender } from '@partsbadger/library';
import dayjs from 'dayjs';
import { PageHeader } from 'components/PageHeader';
import Verify from '../../../components/Verify';

import { Link } from 'react-router-dom';
import QuoteStore from '../../../stores/QuoteStore';
import { useHistory } from 'react-router-dom';
import ComingSoonFeaturesStore from 'stores/ComingSoonFeaturesStore';

import { FeatureTourModal } from '@partsbadger/library';

import FileStore from 'stores/FileStore';

import add_to_cart from 'assets/images/featureTour/partsLibrary/add-to-cart.gif';
import add_part_to_group from 'assets/images/featureTour/partsLibrary/add-part-to-group.gif';
import create_new_group from 'assets/images/featureTour/partsLibrary/create-new-group.gif';
import parts_details from 'assets/images/featureTour/partsLibrary/parts-details.gif';

import { observer } from 'mobx-react';

const { Title } = Typography;

interface IParamsProps {
    search: string | undefined;
    page: number;
    ordering?: string;
}

const ShowPartList: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<IParts[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 40,
        showSizeChanger: false,
    });
    const [search, setSearch] = useState<string>();
    const [url, setUrl] = useState<string | null>(null);
    const [modalVisible, setModalVisible] = useState(false);

    const history = useHistory();

    useEffect(() => {
        UIStore.setSelectedKey(['parts']);
        UIStore.setDocumentTitle('Parts');

        if (UserStore.isVerified) {
            fetch(pagination);
        }
    }, [search]);

    const handleTableChange: TableProps<IParts>['onChange'] = (newPagination, filters, sorter) => {
        setPagination(newPagination);
        fetch(newPagination, filters, sorter);
    };

    const fetch = async (newPagination?: TablePaginationConfig, filters?: any, sorter?: any) => {
        setLoading(true);

        const params: IParamsProps = {
            search: search,
            page: newPagination?.current || 1,
            // hide_draft_orders: true,
        };

        if (sorter?.field) {
            params['ordering'] = `${sorter?.order === 'ascend' ? '' : '-'}${sorter.field}`;
        }

        await api.Parts.all(params)
            .then(response => {
                pagination.total = response.count;
                setData(response.results);
            })
            .catch(err => {
                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: <ErrorRender error={err} />,
                    placement: 'topRight',
                });

                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const emptyTable = () => {
        if (search) {
            return (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<span>Could not find anything with your search</span>}
                />
            );
        }

        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span style={{ color: '#000' }}>See the parts of your orders here!</span>}
            />
        );
    };

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    const tourModalDescriptions = [
        {
            key: 0,
            title: 'Welcome to the Parts Library!',
            description:
                'This page allows you to view, requote, and “Add to Cart” any and all parts we’ve ever quoted for you. Select “View Details” to review the part file, Edit the Quote, view the Order History, and more.',
            img: parts_details,
            alt: 'welcome',
        },
        {
            key: 1,
            title: 'Create Your Groups',
            description:
                'Groups allows you to organize your individual parts into assemblies, projects, and more. Easily manage the parts together and order them as a Group whenever your team is ready.',
            img: create_new_group,
            alt: 'Create Your Groups',
        },
        {
            key: 2,
            title: 'Add Parts To Your Groups',
            description: 'Include separate parts in your group, enabling effortless reordering of these parts.',
            img: add_part_to_group,
            alt: 'Add Parts to Your Groups',
        },
        {
            key: 3,
            title: 'Introducing the Shopping Cart',
            description:
                'Add individual parts to “My Cart” to order them seamlessly via either credit card or by a purchase order upload.',
            img: add_to_cart,
            alt: 'Introducing the Shopping Cart',
        },
    ];

    return (
        <>
            <PageHeader>
                <div className="flex flex-col md:flex-row md:justify-between align-items-center mb-3">
                    <div className="w-full md:w-3/6">
                        <Search
                            allowClear
                            onSearch={e => {
                                setSearch(e);
                            }}
                            placeholder="Search by Part Name or Quote Number"
                            enterButton="Search"
                        />
                    </div>

                    {/*<Button*/}
                    {/*    className="ant-btn-xs mt-1 md:mt-0"*/}
                    {/*    id="request-partsbadger-to-easy-upload"*/}
                    {/*    onClick={() => {*/}
                    {/*        ComingSoonFeaturesStore.setModalHeader(`Coming in ${dayjs().year()}`);*/}
                    {/*        ComingSoonFeaturesStore.setModalTextContent(*/}
                    {/*            'Easily upload your parts library for us to quote and keep here for you to manage.'*/}
                    {/*        );*/}
                    {/*        ComingSoonFeaturesStore.setModalVisible(true);*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Request PartsBadger to Easy Upload*/}
                    {/*</Button>*/}


                </div>
            </PageHeader>

            <div className="container">
                <Alert
                    message={<Title level={3}>New Features!</Title>}
                    description={
                        <>
                            <a
                                className="text-red-600 underline"
                                onClick={() => {
                                    FileStore.setOpenThePartsLibraryTour();
                                }}
                            >
                                Click here
                            </a>{' '}
                            <span>
                                to open up a Walkthrough which will guide you through all the new features on this page!
                            </span>
                        </>
                    }
                    type="info"
                    closable
                    // onClose={onClose}
                    className="mb-4"
                    style={{ backgroundColor: '#FFF', borderColor: '#D6D6D6' }}
                    showIcon={true}
                    icon={<NotificationOutlined className="pt-1" />}
                />
                <Card>
                    <CustomResponsiveTable
                        columns={[
                            {
                                title: 'Preview',
                                dataIndex: 'step_file',
                                width: 60,
                                align: 'center',
                                render: (t, r) => {
                                    if (r.step_file?.image) {
                                        return (
                                            <Tooltip title="View in 3D" className="flex m-auto">
                                                <img
                                                    className="thumbnail-3d-file"
                                                    style={{ width: 60, cursor: 'pointer' }}
                                                    src={r.step_file.image}
                                                    onClick={() => {
                                                        setModalVisible(true);
                                                        setUrl(r?.step_file.file_3djs);
                                                    }}
                                                />
                                            </Tooltip>
                                        );
                                    }
                                    return <FileUnknownOutlined style={{ fontSize: 40 }} />;
                                },
                            },

                            {
                                title: 'Name',
                                dataIndex: 'name',
                                width: 130,
                                render: (text, record) => (
                                    <div className="flex flex-col">
                                        <div>{record.name}</div>
                                        <div style={{ fontSize: 16 }}>
                                            {parseFloat(record?.length).toFixed(3)}
                                            {record?.unit} x {parseFloat(record?.width).toFixed(3)}
                                            {record?.unit} x {parseFloat(record?.height).toFixed(3)}
                                            {record?.unit}
                                        </div>
                                    </div>
                                ),
                            },
                            {
                                title: 'Date',
                                dataIndex: 'created_time',
                                width: 105,
                                render: (text, record) => {
                                    return (
                                        <div>
                                            <div>{dayjs(record.created_time).format('YYYY-MM-DD')}</div>
                                            <div className={'italic'}>By {record.contact?.fullname}</div>
                                        </div>
                                    );
                                },
                            },
                            {
                                title: '# Quotes',
                                dataIndex: 'quote_line_items',
                                width: 100,
                                render: (text, record) => <span>{record.quote_line_items.length}</span>,
                            },

                            {
                                title: '# Orders',
                                dataIndex: 'sales_order_line_items',
                                width: 100,
                                render: (text, record) => <span>{record.sales_order_line_items.length}</span>,
                            },
                            {
                                title: 'Actions',
                                dataIndex: 'Action',
                                width: 150,
                                align: 'center',
                                render: (text, record) => (
                                    <Button
                                        id="action-button"
                                        type={'link'}
                                        icon={<EyeOutlined />}
                                        onClick={() => history.push(`parts/${record.id}`)}
                                        size="large"
                                    >
                                        View details
                                    </Button>
                                ),
                            },
                        ]}
                        loading={loading}
                        data={data}
                        pagination={pagination}
                        onChange={handleTableChange}
                        emptyTable={emptyTable}
                        className="first-step"
                    />
                </Card>
            </div>

            {modalVisible && url && (
                <Drawer open={modalVisible} width={800} onClose={() => setModalVisible(false)} placement={'left'}>
                    <Viewer url={url} />
                </Drawer>
            )}

            <FeatureTourModal
                descriptions={tourModalDescriptions}
                onClose={() => {
                    FileStore.setCloseThePartsLibraryTour();
                }}
                isOpen={!FileStore.isPartsLibraryClosed}
                modalWidth="1100px"
            />
        </>
    );
};

export default observer(ShowPartList);
